import { render, staticRenderFns } from "./SheetTypeInformationModal.vue?vue&type=template&id=0c50fadb&scoped=true"
import script from "./SheetTypeInformationModal.vue?vue&type=script&lang=js"
export * from "./SheetTypeInformationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c50fadb",
  null
  
)

export default component.exports